import { call, put, takeLatest } from 'redux-saga/effects';
import HeroUserApi from 'api-services/HeroUserApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { ACTIVATE_USER } from './actionTypes';
import { doneActivatingUser, errorActivatingUser } from './actionCreators';
export function* activateUser(constAccessParams, action) {
    const result = yield call(HeroUserApi.activateUser, constAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(doneActivatingUser());
    }
    else {
        yield put(errorActivatingUser(result.msg));
    }
}
export function* watchActivateUserCalls(constAccessParams) {
    yield takeLatest(ACTIVATE_USER, activateUser, constAccessParams);
}
//# sourceMappingURL=saga.js.map